const IMAGES = {
  logo: "../assets/images/Billnama_logo.png",
  banner: "../assets/images/Login/new.png",
  businessform: "../assets/images/uploadimage.png",
  gradient: '../assets/images/nft-gradient-bg-rotated.png',
  viewIcon: '../assets/images/ViewIcon.svg',
  premium: '../assets/images/Frame.png',
  success: '../assets/images/sucess.gif',
  download_app: "../assets/images/download_app.png",
  euro_flag: "../assets/images/image.png",
  invoiceIllustration: "../assets/images/dashboard/dashbord_banner.svg",
  freePlanLimitREached: "../assets/images/FreePlanLimitReached.png",
  quotation:"../assets/images/quotation.webp",
  signature:"../assets/images/getimage.png",
  whatsapp:"../assets/images/Generatedwhatsapp1_cropped.png",
  welcome:"../assets/images/welcome.png",
  
  // profilePlaceholder: "/assets/profile-placeholder.png",
  // Add more images as needed

};

/**
 * Function to get an image by key.
 * @param {string} key - The key of the image.
 * @returns {string} - The image URL.
 */
export const getImage = (key) => IMAGES[key] || "/assets/default.png";
